import { render, staticRenderFns } from "./ExamSection.vue?vue&type=template&id=4fe65e45&scoped=true&"
import script from "./ExamSection.vue?vue&type=script&lang=js&"
export * from "./ExamSection.vue?vue&type=script&lang=js&"
import style0 from "./ExamSection.vue?vue&type=style&index=0&id=4fe65e45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe65e45",
  null
  
)

export default component.exports